import React, { useCallback, useState } from 'react';
import { Box, ErrorModal } from '@common-fe/common-fe';
import { toNumber } from 'lodash';

import { SuccessModal } from '@/components/elements';
import { useStore } from '@/modules/transaction/components/ReimburseMe/store/usePaymentMethods.store';
import { TransactionData } from '@/modules/transaction/transaction.types';

import ChoosePaymentMethodWrapper from './ChoosePaymentMethodWrapper';
import useRetryPaymentQuery from './useRetryPayment.query';

interface Props {
  data?: TransactionData;
  close: () => void;
}

const ActionRequiredMessage: React.FC<Props> = ({ data, close }) => {
  const methods = useStore((state) => state.methods);
  const [errorText, setErrorText] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const { retryPayment } = useRetryPaymentQuery({
    claimId: data?.claimId,
    onSuccess: () => {
      setIsSuccess(true);
    },
    onError: (serverErrorText: string) => {
      setErrorText(serverErrorText);
    },
  });
  const onSave = useCallback(async (id?: string) => {
    const selectedPaymentMethod = methods?.find((method) => method?.id === id);
    retryPayment({
      payment_method_id: toNumber(selectedPaymentMethod?.id),
      claim_ids: [toNumber(data?.claimId)],
    });
  }, [methods, retryPayment, data]);

  return (
    <Box data-testId="ActionRequiredMessage">
      <ChoosePaymentMethodWrapper
        onClose={close}
        onSave={onSave}
      />

      <SuccessModal
        testId="action_required_message"
        header="Submitted!"
        buttonText="Got It!"
        visible={isSuccess}
        onSetVisible={() => setIsSuccess(false)}
        buttonStyle={{ width: '200px' }}
      />

      <ErrorModal
        testId="action_required_message"
        header="Error"
        helpText={errorText}
        buttonText="Cancel"
        visible={Boolean(errorText)}
        onSetVisible={() => setErrorText('')}
      />
    </Box>
  );
};

export default ActionRequiredMessage;
